import {
  CloseOutlined,
  DatabaseOutlined,
  FileSearchOutlined,
  LoginOutlined,
  LogoutOutlined,
  PieChartOutlined,
  ProjectOutlined,
  UserOutlined
} from '@ant-design/icons'
import { Button, Menu } from 'antd'
import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { IS_ADMIN } from '../../constants'
import LogoImg from '../../media/builty-logo.svg'
import './Nav.scss'
import {
  fetchProfile,
  selectInfo,
} from '../../features/profile/profileSlice';
import { useSelector, useDispatch } from 'react-redux';

const { SubMenu } = Menu

export const Nav = ({ isOpen, onClose, isLoggedIn, onLogin, onLogOut }) => {
  const location = useLocation()
  const isAdmin = localStorage.getItem(IS_ADMIN)
  const { email } = useSelector(selectInfo);
 
  const showAdminMenu = () => {
    console.log('isAdmin', isAdmin)
    if (isAdmin === 'null' || isAdmin === 'false') { 
      return false
    } else if (isAdmin === 'true') {
      return true
    }
  }

  return (
    <nav className={`c-nav ${isOpen ? 'is-open' : ''}`}>
      <div className="c-nav__inner">
        <div className="c-nav__close-btn">
          <Button onClick={onClose} icon={<CloseOutlined />} size="large" />
        </div>
        <div className="c-nav__logo">
          <div>
            <a href="https://builty.app">
              <img
                src={LogoImg}
                alt="Builty Logo"
                width="210"
                height="31"
                className="c-nav__logo-img"
              />
            </a>
          </div>
          <div className="c-nav__logo-beta">beta</div>
        </div>

        {isLoggedIn && <div>
          <div className='c-nav_user_text'>
          Currently logged in as: 
          </div>
          <Menu
          className='nav_user_menu'
          mode="inline" selectable={false} >
          <Menu.Item icon={<UserOutlined />} >
          <div className="c-nav_user">{email}</div>
          </Menu.Item>
          </Menu>
        </div>}

        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          defaultOpenKeys={['nav-account']}
          className="c-nav__menu"
        >
          <Menu.Item key="/" icon={<PieChartOutlined />}>
            <Link to="/">Coverage</Link>
          </Menu.Item>
          <Menu.Item key="/permit-lookup" icon={<FileSearchOutlined />}>
            <Link to="/permit-lookup">Permit Lookup</Link>
          </Menu.Item>

          {isLoggedIn && (
            <>
              <Menu.Item key="/api-usage" icon={<DatabaseOutlined />}>
                <Link to="/api-usage">API Usage</Link>
              </Menu.Item>
              <SubMenu
                key="nav-account"
                icon={<ProjectOutlined />}
                title="Account"
              >
                {/* <Menu.Item key="/billing">
                  <Link to="/billing">Billing</Link>
                </Menu.Item> */}
                <Menu.Item key="/settings">
                  <Link to="/settings">Settings</Link>
                </Menu.Item>
                {showAdminMenu() && (
                  <Menu.Item key="/s3-admin">
                    <Link to="/s3-admin">AWS</Link>
                  </Menu.Item>
                )}
                {showAdminMenu() && (
                  <Menu.Item key="/approve-user">
                    <Link to="/approve-user">Approve User</Link> </Menu.Item>)}
                {!showAdminMenu() && (
                  <Menu.Item key="/s3-browser">
                    <Link to="/s3-browser">S3 browser</Link>
                  </Menu.Item>
                )}
              </SubMenu>
            </>
          )}
          {/* <Menu.Item key="/documentation" icon={<ReadOutlined />}>
            <Link to="/documentation">Documentation</Link>
          </Menu.Item> */}
        </Menu>
        <div className="c-nav__log-btn">
          {isLoggedIn ? (
            <Button size="medium" icon={<LogoutOutlined />} onClick={onLogOut}>
              Log out
            </Button>
          ) : (
            <Button
              size="medium"
              type="primary"
              icon={<LoginOutlined />}
              onClick={onLogin}
            >
              Log in
            </Button>
          )}
        </div>
      </div>
    </nav>
  )
}
